<template>
  <div class="row" v-show="showMoreFeatures">
    <div class="row bg-primary">
      <div class="columns">
        <div class="column is-4">
          <h4>
            Micro level analysis <small>create a widget to make analysis</small>
          </h4>
        </div>
        <div class="column">
          Indicator selection here
        </div>
        <div class="column">
          Data source selection here
        </div>
        <div class="column">
          Select period here
        </div>
      </div>
    </div>

    <!-- The section to compare indicators and data sources -->
    <div class="row web-features" style="border: 1px solid #1E70EC; font-family: 'Roboto', 'Open Sans', sans-serif">
      <span>
        <!-- <draggable v-model="myArray"
            :options="{group:'widgets', handle: '.glyphicon-move', animation: 150}"
            @start="drag=true" @end="drag=false"> -->
          <!-- <transition-group tag="div" name="slide"> -->
            <div class="col-xs-12 col-sm-6 col-md-4" v-for="(indicator_value, key) in widgets" :key="key">
                <div class="panel panel-primary widget" :id="'widget_' + key">
                    <div class="panel-heading bg-primary">
                        <span class="glyphicon glyphicon-stats" aria-hidden="true" v-tooltip.top="'drag'"></span>
                        <span class="pull-right widget-tools">
                            <!-- <span class="badge"> -->
                              <!-- <b-dropdown v-if="componentType === 'Charts'" position="is-bottom-left" v-model="specificChartType[key]">
                                <a style="color: white" slot="trigger">
                                  <span>Chart type</span>
                                  <i class="fa fa-caret-down"></i>
                                </a>
                                <b-dropdown-item v-for="plotType in specificComponentOptions" :key="plotType" :value="plotType" @click="dropdownChangedChart(plotType, key)">
                                  <span>{{plotType}}</span>
                                </b-dropdown-item>
                              </b-dropdown>
                              <b-dropdown v-else position="is-bottom-left" v-model="specificMapType[key]">
                                <a style="color: white" slot="trigger">
                                  <span>Map type</span>
                                  <i class="fa fa-caret-down"></i>
                                </a>
                                <b-dropdown-item v-for="plotType in specificComponentOptions" :key="plotType" :value="plotType" @click="dropdownChangedMap(plotType, key)">
                                  <span>{{plotType}}</span>
                                </b-dropdown-item>
                              </b-dropdown> -->
                            <!-- </span> -->
                            <!-- <span class="badge" :id="'destroy_widget' + key">
                                <i class="fa fa-times" :id="key" @click="toggleWidget($event)"></i>
                            </span> -->
                        </span>
                    </div>
                    <div class="panel-body">
                      <!-- <div class="hidden"><label>{{sourceClicked}}</label></div> -->
                      <!-- <plot-map v-show="componentType==='Map'" :yearOptions="regionalChartYearOptionsData" :indicatorOptions="optionIndicators.slice(0)" :data="[indicator_value, relativeIndicators[key], sourceClicked, selectedYear]"
                          :maptype="specificMapType[key]"></plot-map>
                      <plot-chart v-show="componentType==='Charts'" :yearOptions="regionalChartYearOptionsData" :indicatorOptions="optionIndicators.slice(0)" :chartData="[indicator_value, relativeIndicators[key], sourceClicked, lsData.slice(0)]"
                          :chartType="specificChartType[key]"></plot-chart> -->
                    </div>
                </div>
            </div>
          <!-- </transition-group> -->
        <!-- </draggable> -->
      </span>
      <v-speed-dial
        v-model="fab"
        :top="false"
        :bottom="true"
        :right="true"
        :left="false"
        :fixed="false"
        :absolute="false"
        :direction="'top'"
        :open-on-hover="false"
        :transition="transition"
      >
      <!-- slot="activator" -->
      <v-btn
        v-model="fab"
        color="indigo darken-2"
        slot="activator"
        dark
        fab
        :ripple="false"
        @click="addWidget()"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-speed-dial>
    </div>
  </div>
</template>

<script>
export default {
  name: 'widget-container',
  props: ['showComponents', 'showMoreFeatures'],
  components: {},
  data() {
    return {
      // start floating buttons variables
      fab: false,
      fling: false,
      tabs: null,
      transition: 'slide-y-reverse-transition',
      widgets: []
    }
  },
  methods: {
    addWidget() {

    }
  },
  watch: {
    showComponents(val, oldval) {
      console.log(val, oldval);
    }
  }

}
</script>




// WEBPACK FOOTER //
// widgetContainer.vue?50d4b351